import React, { useEffect, useState } from 'react';
import { getAssessmentBEIQuestion } from '../../../../../../../utils/api_service/Behavioral';
import { JobDescription } from '../../../../../../../utils/types/JobOpenings';
import { BEIAttributesSidebar, BEIQuestionsContent } from './Components';

interface Props {
    jobDescription?: JobDescription,
    assessmentID: string
}

export const BEIQuestions = ({ jobDescription, assessmentID }: Props) => {
  const [selectedAttributes, setSelectedAttributes] = useState<string[]>([]);
  const [shouldGenerateQuestions, setShouldGenerateQuestions] = useState(false);
  const [questions, setQuestions] = useState<any[]>([]);
  const [editingTimeLimit, setEditingTimeLimit] = useState<number>(300);

  const handleGenerateQuestions = (attributes: string[]) => {
    setSelectedAttributes(attributes);
    setShouldGenerateQuestions(true);
  };

  useEffect(() => {
    const fetchBEIQuestions = async () => {
      try {
        const response = await getAssessmentBEIQuestion(assessmentID);
        if (response.ok) {
          const data = await response.json();
          const formatted = data.questions.map((q:any, index: number) => ({
            id: index + 1,
            question: q.question,
            attribute: q.attribute,
          }));
          setEditingTimeLimit(data.timeLimit);
          const attrList = formatted.map((q:any) => q.attribute);
          setSelectedAttributes(attrList);
          setQuestions(formatted);
        }

      } catch (e) {
        console.error(e);
      }
    };

    fetchBEIQuestions();
  }, []);

  return (
    <div className='flex flex-col gap-4 min-h-[70vh] h-full lg:min-h-[80vh] lg:flex-row'>
      <BEIAttributesSidebar
          jobDescription={jobDescription}
          onGenerateQuestions={handleGenerateQuestions}
      />
      { /* Scrollable content area */ }
      <div className='min-w-0 flex-1 overflow-y-auto'>
        <BEIQuestionsContent
            assessmentID={assessmentID}
            jobDescription={jobDescription}
            selectedAttributes={selectedAttributes}
            shouldGenerate={shouldGenerateQuestions}
            questions={questions}
            setQuestions={setQuestions}
            editingTimeLimit={editingTimeLimit}
            setEditingTimeLimit={setEditingTimeLimit
            }
        />
      </div>
    </div>
  );
};
